const mySoftSkills = {
  creativityTitle: "mySoftSkills.creativityTitle",
  creativityDesc: "mySoftSkills.creativityDesc",
  communicationTitle: "mySoftSkills.communicationTitle",
  communicationDesc: "mySoftSkills.communicationDesc",
  adaptabilityTitle: "mySoftSkills.adaptabilityTitle",
  adaptabilityDesc: "mySoftSkills.adaptabilityDesc",
  problemSolvingTitle: "mySoftSkills.problemSolvingTitle",
  problemSolvingDesc: "mySoftSkills.problemSolvingDesc",
  teamworkTitle: "mySoftSkills.teamworkTitle",
  teamworkDesc: "mySoftSkills.teamworkDesc",
  detailOrientedTitle: "mySoftSkills.detailOrientedTitle",
  detailOrientedDesc: "mySoftSkills.detailOrientedDesc",
  criticalThinkingTitle: "mySoftSkills.criticalThinkingTitle",
  criticalThinkingDesc: "mySoftSkills.criticalThinkingDesc",
  leadershipTitle: "mySoftSkills.leadershipTitle",
  leadershipDesc: "mySoftSkills.leadershipDesc",
  willingToLearnTitle: "mySoftSkills.willingToLearnTitle",
  willingToLearnDesc: "mySoftSkills.willingToLearnDesc",
  workEthicTitle: "mySoftSkills.workEthicTitle",
  workEthicDesc: "mySoftSkills.workEthicDesc",
};

export const softSkills = [
  {
    id: 1,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FcreativityFront.png?alt=media&token=3dc3123e-c7f0-428f-9884-dae6204bd6f8",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FcreativityBack.png?alt=media&token=547994fa-0251-4d6b-a536-5755d5f7fd88",
    title: `${mySoftSkills.creativityTitle}`,
    description: `${mySoftSkills.creativityDesc}`,
  },
  {
    id: 2,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FcommunicationFront.png?alt=media&token=a8403394-3476-4c11-9114-9156ddb60f3d",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FcommunicationBack.png?alt=media&token=8860c3c3-396c-4492-b9d0-20eab6996ac3",
    title: `${mySoftSkills.communicationTitle}`,
    description: `${mySoftSkills.communicationDesc}`,
  },
  {
    id: 3,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FadaptabilityFront.png?alt=media&token=6b3132d2-94c4-4f69-b710-1ab9b32777d9",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FadaptabilityBack.png?alt=media&token=4a9fa6c4-ffb8-4a92-95c3-5be7c19cf697",
    title: `${mySoftSkills.adaptabilityTitle}`,
    description: `${mySoftSkills.adaptabilityDesc}`,
  },
  {
    id: 4,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FproblemSolvingFront.png?alt=media&token=f7085693-2910-4c68-a73e-4cca36f25122",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FproblemSolvingBack.png?alt=media&token=38cf9d70-807d-47fd-88b6-4369c031bd62",
    title: `${mySoftSkills.problemSolvingTitle}`,
    description: `${mySoftSkills.problemSolvingDesc}`,
  },
  {
    id: 5,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FteamworkFront.png?alt=media&token=9732ff42-8ba1-46dc-bc9f-ca3b8363fd2b",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FteamworkBack.png?alt=media&token=7a52be00-5ef6-4198-a9c8-791baba74293",
    title: `${mySoftSkills.teamworkTitle}`,
    description: `${mySoftSkills.teamworkDesc}`,
  },
  {
    id: 6,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FdetailOrientedFront.png?alt=media&token=d9c2af08-71e6-434c-911a-03aa908c88f7",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FdetailOrientedBack.png?alt=media&token=1d4a7f77-2137-4a97-a314-37a827f2a102",
    title: `${mySoftSkills.detailOrientedTitle}`,
    description: `${mySoftSkills.detailOrientedDesc}`,
  },
  {
    id: 7,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FcriticalThinkingFront.png?alt=media&token=326d61c4-ada1-4d7e-9a6a-5aa522a6c401",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FcriticalThinkingBack.png?alt=media&token=7721b02d-f04b-4491-87d3-25a9b8e88196",
    title: `${mySoftSkills.criticalThinkingTitle}`,
    description: `${mySoftSkills.criticalThinkingDesc}`,
  },
  {
    id: 8,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FleadershipFront.png?alt=media&token=f7665d81-efe4-4d27-a601-d2541067f6b8",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FleadershipBack.png?alt=media&token=d6dfc927-8449-49ce-a907-d5879be08d18",
    title: `${mySoftSkills.leadershipTitle}`,
    description: `${mySoftSkills.leadershipDesc}`,
  },
  {
    id: 9,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FwilltToLearnFront.png?alt=media&token=6211c94d-3e9e-4be3-b29c-b86f779949b0",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FwilltToLearnBack.png?alt=media&token=5c94df43-241a-4f34-afd9-9eb45fc88820",
    title: `${mySoftSkills.willingToLearnTitle}`,
    description: `${mySoftSkills.willingToLearnDesc}`,
  },
  {
    id: 10,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FcollaborationFront.png?alt=media&token=785458df-c72c-4781-869d-a447156d59d2",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FcollaborationBack.png?alt=media&token=75b251ce-778b-4e4e-9400-41a139effc2a",
    title: `${mySoftSkills.workEthicTitle}`,
    description: `${mySoftSkills.workEthicDesc}`,
  },
];

const workingOnSoftSkills = {
  timeManagmentTitle: "workingOnSoftSkills.timeManagmentTitle",
  timeManagmentDesc: "workingOnSoftSkills.timeManagmentDesc",
  activeListeningTitle: "workingOnSoftSkills.activeListeningTitle",
  activeListeningDesc: "workingOnSoftSkills.activeListeningDesc",
  selfAwarenessTitle: "workingOnSoftSkills.selfAwarenessTitle",
  selfAwarenessDesc: "workingOnSoftSkills.selfAwarenessDesc",
  organizationTitle: "workingOnSoftSkills.organizationTitle",
  organizationDesc: "workingOnSoftSkills.organizationDesc",
  selfControlTitle: "workingOnSoftSkills.selfControlTitle",
  selfControlDesc: "workingOnSoftSkills.selfControlDesc",
};

export const workingSoftSkills = [
  {
    id: 1,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FtimeManagementFront.png?alt=media&token=4d694fd6-2c8b-4d48-bccc-2934f6a6a6ce",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FtimeManagementBack.png?alt=media&token=ea21fe9d-149f-40bf-b844-1c0f53157e2b",
    title: `${workingOnSoftSkills.timeManagmentTitle}`,
    description: `${workingOnSoftSkills.timeManagmentDesc}`,
  },
  {
    id: 2,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FactiveListeningFront.png?alt=media&token=0360b0f8-4dac-4392-8c2a-14752da771f4",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FactiveListeningBack.png?alt=media&token=b34d28fb-c793-4322-b2be-91b48c89cec2",
    title: `${workingOnSoftSkills.activeListeningTitle}`,
    description: `${workingOnSoftSkills.activeListeningDesc}`,
  },
  {
    id: 3,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FselfAwarenessFront.png?alt=media&token=3de826dd-2c2e-4d61-bb69-85f0f55f84d2",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FselfAwarenessBack.png?alt=media&token=ccf5c048-5a2b-439b-8480-c434c81836fa",
    title: `${workingOnSoftSkills.selfAwarenessTitle}`,
    description: `${workingOnSoftSkills.selfAwarenessDesc}`,
  },
  {
    id: 4,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2ForganizationFront.png?alt=media&token=77dbb41f-91ec-4ee5-8fe3-ec491d4c3f7f",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2ForganizationBack.png?alt=media&token=1908beab-363c-4010-904c-69eea9316778",
    title: `${workingOnSoftSkills.organizationTitle}`,
    description: `${workingOnSoftSkills.organizationDesc}`,
  },
  {
    id: 5,
    imageFront:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FselfControlFront.png?alt=media&token=fb4fe7f5-ddab-4960-91fd-cd5807e22deb",
    imageBack:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FSkills%2FsoftSkills%2FselfControlBack.png?alt=media&token=e35a4209-aca2-462a-ac75-8972fc55162e",
    title: `${workingOnSoftSkills.selfControlTitle}`,
    description: `${workingOnSoftSkills.selfControlDesc}`,
  },
];
